// extracted by mini-css-extract-plugin
export default {"root":"Anatomy_root__RYdS1"};